/**
 * @description audio module
 * @author wulijie
 */
// 配置多语言
// import './locale/index'

// 导入样式
import './style/index.css'

import wangEditorAudioModule from './module/index'
export default wangEditorAudioModule